export class ClientContactsColumnDefintion{
   public values?: any[];
   constructor(
       public field: string,
       public title: string = "",
       public template?:string,
       public hidden:boolean = false,
       public width:number = 130,
       public editor?: any | Function){}
}


// WEBPACK FOOTER //
// ./app/insa-models/client-contactColumnDefinition.ts